import { supabase } from "../Supabase";

function mapRow(r) {
  return {
    id: r.id,
    name: r.name,
    address: r.address ?? null,
    city: r.city ?? null,
    postCode: r.post_code ?? null,
    phoneNumber: r.phone_number ?? null,
    email: r.email ?? null,
    createdAt: r.created_at,
  };
}

export async function getCustomersForUser() {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData?.user) throw new Error("Not authenticated");

  const { data, error } = await supabase
    .from("customers")
    .select(
      `
        id,
        name,
        address,
        city,
        post_code,
        phone_number,
        email,
        created_at
      `
    )
    .eq("user_id", userData.user.id)
    .order("created_at", { ascending: false });

  if (error) throw error;
  return (data ?? []).map(mapRow);
}

export async function createCustomer(input) {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData?.user) throw new Error("Not authenticated");

  const { data, error } = await supabase
    .from("customers")
    .insert({
      user_id: userData.user.id,
      name: input.name,
      address: input.address ?? null,
      city: input.city ?? null,
      post_code: input.postCode ?? null,
      phone_number: input.phoneNumber ?? null,
      email: input.email ?? null,
    })
    .select("*")
    .single();

  if (error) throw error;
  return mapRow(data);
}

export async function updateCustomer(input) {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData?.user) throw new Error("Not authenticated");

  const { data, error } = await supabase
    .from("customers")
    .update({
      name: input.name,
      address: input.address ?? null,
      city: input.city ?? null,
      post_code: input.postCode ?? null,
      phone_number: input.phoneNumber ?? null,
      email: input.email ?? null,
    })
    .eq("id", input.id)
    .eq("user_id", userData.user.id)
    .select("*")
    .single();

  if (error) throw error;
  return mapRow(data);
}
